import React from 'react';
import AcessoNegado from './AcessoNegado';
import { useVerificarAcessoAba } from '../../hooks/usePermissoes';

interface AbaProtegidaProps {
  children: React.ReactNode;
  nomeAba: string;
}

const AbaProtegida: React.FC<AbaProtegidaProps> = ({ children, nomeAba }) => {
  const { temAcesso, carregando } = useVerificarAcessoAba(nomeAba);

  try {
    if (carregando) {
      return (
        <div className="flex items-center justify-center min-h-screen">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          <span className="ml-4 text-gray-600">Verificando permissões...</span>
        </div>
      );
    }

    if (!temAcesso) {
      return <AcessoNegado aba={nomeAba} />;
    }

    return <>{children}</>;
  } catch (error) {
    console.error('Erro no AbaProtegida:', error);
    // Em caso de erro, permitir acesso para não quebrar a aplicação
    return <>{children}</>;
  }
};

export default AbaProtegida;
